import { AuthAction } from './actions';
import { AuthState } from './types';

const initialState: AuthState = {
  isLoggedIn: false,
  username: '',
  userAccountId: '',
};

export function authReducer(state: AuthState = initialState, action: AuthAction): AuthState {
  switch (action.type) {
    case 'AUTH_LOGIN_SUCCESS':
      return {
        ...state,
        isLoggedIn: true,
        username: action.data.username,
      };

    case 'AUTH_SET_USER_ACCOUNT_ID':
      return {
        ...state,
        userAccountId: action.data.userAccountId,
      };

    case 'AUTH_SET_ACCOUNT': {
      return {
        ...state,
        account: action.data.account,
      };
    }
    default:
      return state;
  }
}
